<form [formGroup]="form" (ngSubmit)="onSubmit()" appPermissionControl="P291F0001">
    <div class="form-row">
        <div class="form-field">
            <input pInputText type="number" formControlName="orden" class="form-control" 
                [placeholder]="'Ingrese el orden'" 
                min="1" appPermissionControl="P291K0001">
            <label>Orden</label>
        </div>
    </div>

    <div class="form-row">
        <div class="form-field">
            <p-dropdown 
                formControlName="campo" 
                [options]="camposOptions" 
                optionLabel="descripcion" 
                appendTo="body"
                optionValue="descripcion"
                [filter]="true"
                placeholder="Seleccione el campo"
                class="w-100" appPermissionControl="P291K0002">
            </p-dropdown>
            <label>Campo</label>
        </div>
    </div>

    <div class="form-row">
        <div class="form-field">
            <input pInputText type="text" formControlName="etiqueta" class="form-control" 
                [placeholder]="'Ingrese la etiqueta'" appPermissionControl="P291K0003">
            <label>Etiqueta</label>
        </div>
    </div>

    <div class="button-section">
        <button mat-flat-button class="btn-success btn-menu" (click)="onSubmit()"
            [disabled]="!form.valid || loading" appPermissionControl="P291B0001">
            <mat-icon>save</mat-icon>
            Guardar
        </button>
    </div>
</form> 